import {useRequiredConfig} from '@domain/shifthandover'
import {useUpmPlantTimezone} from '@hconnect/upm'
import {useEffect} from 'react'
import {useLocation, useNavigate} from 'react-router'

import {DocumentsView} from '../containers/documents/DocumentsView'
import {useFilteredInstructions} from '../hooks/api/useFilteredInstructions'
import {useInstructionsPageLastVisited} from '../hooks/useInstructionsPageLastVisited'
import {useQueryParameterForViewMode, viewModeToUrlParams} from '../hooks/useQueryParameter'
import {ViewMode} from '../types'
import {DocumentSearchCriteria} from '../types/documents.types'

type DocumentsPageProps = {
  plantId: string
}

export const DocumentsPage = ({plantId}: DocumentsPageProps) => {
  const navigate = useNavigate()
  const {pathname} = useLocation()
  const {country} = useRequiredConfig(plantId)
  const timezone = useUpmPlantTimezone()
  const viewMode = useQueryParameterForViewMode()

  // todo add filters
  const filterSettings: DocumentSearchCriteria = {}
  const eventQuery = useFilteredInstructions({plantId, timezone, settings: filterSettings})
  const {setLastVisited} = useInstructionsPageLastVisited()

  useEffect(() => {
    setLastVisited()
    return () => {
      setLastVisited()
    }
  }, [setLastVisited])

  const setViewMode = (nextViewMode: ViewMode) => {
    const params = viewModeToUrlParams(nextViewMode).toString()
    void navigate(params ? `${pathname}?${params}` : pathname)
  }

  return (
    <DocumentsView
      plantId={plantId}
      country={country}
      documents={eventQuery.data}
      isLoading={eventQuery.isPending || eventQuery.isFetching}
      viewMode={viewMode}
      setViewMode={setViewMode}
    />
  )
}
